import { IHttpApi } from '@cian/http-api';
import {
  fetchFilterPikNewbuildings,
  IFilterPikNewbuildingsResponse,
  IFilterPikNewbuildingsResponse200,
  IFilterPikNewbuildingsResponse400,
} from '../../repositories/monolith-python/v1/filter-pik-newbuildings';
import { mapNewBuildingIdsResponse, mapNewBuildingIdsResponseError } from '../../mappers/transformNewBuildingIds';
import { IFilterPikNewbuildingsRequest } from '../../types/residentials';
import { assertNotFoundError } from './assert/assertNotFoundError';

export const getFilteredResidentialComplexes = async ({
  httpApi,
  parameters,
  subdomain,
}: {
  httpApi: IHttpApi;
  parameters: IFilterPikNewbuildingsRequest;
  subdomain: string;
}): Promise<number[]> => {
  const response = await fetchFilterPikNewbuildings<
    IFilterPikNewbuildingsResponse200,
    IFilterPikNewbuildingsResponse400
  >({
    httpApi,
    parameters,
    mappers: {
      200: mapNewBuildingIdsResponse,
      400: mapNewBuildingIdsResponseError,
    },
    config: { subdomain },
  });

  assertNotFoundError(response);

  if (response.statusCode !== 200) {
    return [];
  }

  return (
    ((response as IFilterPikNewbuildingsResponse200).response as IFilterPikNewbuildingsResponse).data.newbuildingIds ||
    []
  );
};
